module.exports = __webpack_public_path__ + "img/Email-Notifications.bdfcda4b.svg";